<script setup lang="ts">
interface Emits {
  (e: "click", key: string): void;
}

const emit = defineEmits<Emits>();

const props = defineProps({
  label: String,
  key: String,
  isSelected: Boolean,
});

const handleClick = () => {
  emit("click", props.key ?? "");
};
</script>
<template>
  <button
    :class="['btn-option', isSelected && 'btn-active']"
    @click="handleClick"
  >
    <span>{{ props.label }}</span>
  </button>
</template>

<style lang="scss" scoped>
@import "@/assets/scss/_constants.scss";

.btn-options-container {
  display: flex;
  flex-direction: column;
}
.btn-option {
  color: $pj-color-black;
  width: 100%;
  text-align: left;
  border: 1px solid #d1d1d1;
  border-radius: 5px;
  padding: 20px 16px;
  margin-top: 12px;
  background: #ffffff;
  span {
    font-weight: 500;
    font-size: 14px;
    line-height: 26px;
    color: $pj-color-black;
  }
}
.btn-active {
  border: 1px solid #007c3b;
}
</style>
